// removed by extract-text-webpack-plugin
module.exports = {"titleSearchBox":"_3GCBGYt5PgEb7oahY7_Ito","h1Title":"_26sFMAy9kOoqr4rys2bxDd","searchTitle":"h66gw1CJN5d5pbxcC38yl","sortDropdown":"_2UsGOcllF6OsQV7egYVl05","is-open":"_3s9SGbGy5dfV0kO6U6t0Yq","saveSearchContainer":"_1i6tv0cGfjUw7cpNfP28Cz","mobileLoadingBlock":"_3flStvMZwKR6TFbtsBn2on","sortPart":"T0PyU8fRh5B4oguJsHC29"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyListTopBlock/PropertyListTopBlock.scss
// module id = 1735
// module chunks = 0